<ng-container>
    <!-- <hr *ngIf="i + 1 < (contextMenuItems?.length ?? 0)" /> -->

    @for (menuItem of contextMenuItems; track menuItem; let i = $index) {
        <div 
            class="menu-link"
            (click)="onContextMenuClick($event, menuItem.menuEvent)" 
            [innerHTML]="menuItem.menuText">
        </div>
    }

    <!-- <button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" style="display: none;"></button>
    <mat-menu #menu="matMenu">    
        @for (menuItem of contextMenuItems; track menuItem; let i = $index) {
            <button 
                mat-menu-item
                (click)="onContextMenuClick($event, menuItem.menuEvent)" 
                [innerHTML]="menuItem.menuText">
            </button>
        }
    </mat-menu> -->
</ng-container>